import React from 'react';
import PropTypes from 'prop-types';
import { useClientIdentificationCardLogic } from './ClientIdentificationCardLogic';
import Card from '../../layout/Card/Card';
import FormRow from '../../form/FormRow/FormRow';
import FormColumn from '../../form/FormColumn/FormColumn';
import InputField from '../../form/InputField/InputField';
import NumericField from '../../form/NumericField/NumericField';
import styles from './ClientIdentificationCard.module.css';
import ToggleSwitch from '../../form/ToggleSwitch/ToggleSwitch';
import Section from '../../layout/Section/Section';
import { LIMITES } from '../../../utils/constantes';
import { formatCpf } from '../../../utils/formatters';

const ClientIdentificationCard = ({ setClientData, onTotalIncomeChange }) => {
  const {
    buyers,
    pagadoria,
    valorComissao,
    handleBuyerChange,
    addBuyer,
    removeBuyer,
    handlePagadoriaChange,
    handleValorComissaoChange
  } = useClientIdentificationCardLogic(setClientData, onTotalIncomeChange);

  const handleCpfChange = (index, value) => {
    const formattedCpf = formatCpf(value);
    handleBuyerChange(index, 'cpf', formattedCpf);
  };

  return (
    <Card title="Compradores">      {buyers.map((buyer, index) => (
        <div
          key={`buyer-${buyer.id || index}`}
          className={`${styles.buyerSection} ${index > 0 ? styles.additionalBuyer : ''}`}
        >
          {index > 0 && (
            <FormRow>
              <FormColumn cols={12}>
                <h4 className={styles.buyerTitle}>Comprador(a) {index + 1}</h4>
              </FormColumn>
            </FormRow>
          )}

          <FormRow>
            <FormColumn cols={5}>
              <InputField
                id={`nomeCliente_${index}`}
                label="Nome"
                value={buyer.name}
                onChange={(e) => handleBuyerChange(index, 'name', e.target.value)}
                placeholder="Digite o nome completo"
              />
            </FormColumn>
             <FormColumn cols={2}>
              <InputField
                id={`cpfCliente_${index}`}
                label="CPF"
                value={buyer.cpf}
                onChange={(e) => handleCpfChange(index, e.target.value)}
                placeholder="Digite o CPF"
                maxLength={14}
              />
            </FormColumn>
            <FormColumn cols={2}>
              <NumericField
                id={`rendaCliente_${index}`}
                label="Renda"
                value={buyer.income}
                onChange={(e) => handleBuyerChange(index, 'income', e.target.value)}
                placeholder="Digite a renda"
                currency={true}
                required={true}
              />
            </FormColumn>
            <FormColumn cols={2}>
              <InputField
                id={`dataNascimento_${index}`}
                label="Data de Nascimento"
                value={buyer.birthDate}
                onChange={(e) => handleBuyerChange(index, 'birthDate', e.target.value)}
                type="date"
                className={styles.dateField}
              />
            </FormColumn>
            <FormColumn cols={1}>
              <div className={styles.actionButtons}>
                <span className={styles.actionButtonsLabel} aria-hidden="true">Ações</span>
                <div className={styles.actionButtonsContainer}>
                  {/* Plus icon only appears for the last buyer */}
                  {index === buyers.length - 1 && buyers.length < LIMITES.COMPRADORES && (
                    <button
                      className={styles.addBuyerBtn}
                      onClick={addBuyer}
                      title="Adicionar comprador"
                      aria-label="Adicionar novo comprador"
                      aria-describedby="buyer-add-desc"
                      type="button"
                    >
                      <i className="fas fa-plus" aria-hidden="true"></i>
                      <span id="buyer-add-desc" className="sr-only" hidden>
                        Adicionar um novo comprador à simulação
                      </span>
                    </button>
                  )}
                  {index > 0 && (
                    <button
                      className={styles.removeBuyerIcon}
                      title="Remover comprador"
                      onClick={() => removeBuyer(index)}
                      aria-label={`Remover comprador ${index + 1}: ${buyer.name || 'sem nome'}`}
                      type="button"
                      aria-describedby={`buyer-removal-desc-${index}`}
                    >
                      <i className="fas fa-trash" aria-hidden="true"></i>
                      <span id={`buyer-removal-desc-${index}`} className="sr-only" hidden>
                        Remover este comprador da simulação
                      </span>
                    </button>
                  )}
                </div>
              </div>
            </FormColumn>
          </FormRow>
        </div>
      ))}

      <Section title="Comissão" variant="subsection">
        <FormRow>
          <FormColumn>
            <ToggleSwitch
              id="pagadoria"
              label="Pagadoria"
              isChecked={pagadoria}
              onChange={handlePagadoriaChange}
            />
          </FormColumn>
          {pagadoria && (
            <FormColumn cols={6} >
              <NumericField
                id="valorComissao"
                label="Percentual de comissão pagadoria"
                value={valorComissao}
                onChange={handleValorComissaoChange}
                placeholder="Informe o valor da comissão"
                percentage={true}
                max="10"
                step="0.01"
                tooltip="Informe o percentual de referência baseado na prestação de serviço do usuário"
              />
            </FormColumn>
          )}
        </FormRow>
      </Section>
    </Card>  );
};

ClientIdentificationCard.propTypes = {
  setClientData: PropTypes.func.isRequired,
  onTotalIncomeChange: PropTypes.func.isRequired
};

export default ClientIdentificationCard;